import { render, staticRenderFns } from "./GraphDetail25.vue?vue&type=template&id=3b831301&scoped=true"
import script from "./GraphDetail25.vue?vue&type=script&lang=js"
export * from "./GraphDetail25.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b831301",
  null
  
)

export default component.exports